import styled from 'styled-components'

export const StyledFilters = styled.div`
  .pointer {
    cursor: 'pointer';
  }
`
